import { UpdateWorkOrderComplementRequest } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { WorkOrderComplementFormData } from '../../../Complements/ComplementForm';
import { DateTimeFormat } from '@/utils/moment';

type CallbackData = Omit<
  UpdateWorkOrderComplementRequest,
  'workOrderId' | 'complementId'
>;

export function handlerWorkorderGenarlInfoValues(
  values: WorkOrderComplementFormData,
  callback: (data: CallbackData) => void,
) {
  callback({
    ...values,
    entryDate: values.entryDate
      ? values.entryDate?.format(DateTimeFormat)
      : undefined,
    authorizationDate: values.authorizationDate
      ? values.authorizationDate?.format(DateTimeFormat)
      : undefined,
    closingDate: values.closingDate
      ? values.closingDate?.format(DateTimeFormat)
      : undefined,
    estimatedLeaveDate: undefined,
    returnDate: values.returnDate
      ? values.returnDate?.format(DateTimeFormat)
      : undefined,
    insurerDeductibleAmount: values.insurerDeductibleAmount ?? 0,
  });
}
